<form
  [formGroup]="form"
  (ngSubmit)="onSave()"
  class="flex flex-col">
  <div class="flex flex-col">
    <div
      id="header"
      class="flex w-full justify-between mt-6 border-b border-neutral-300 sticky top-0 bg-white py-4 z-50">
      <span class="text-[18px] font-black">
        <i
          [class.pi]="true"
          [class.pi-file-arrow-up]="true"
          style="font-size: 2rem"></i>
        DESPLEGAR SISTEMA DE IA
      </span>
      <div
        id="buttons"
        class="flex gap-4">
        <app-buttons
          [label]="'Cancelar'"
          (click)="cancel()" />
        <app-buttons
          [label]="'Volver al paso anterior'"
          (click)="backPage()" />
        <app-buttons
          [label]="'Desplegar sistema'"
          [disabled]="form.invalid"
          [classes]="'bg-primary-base text-primary-light'"
          (click)="confirm()"
          type="button" />
      </div>
    </div>

    <div class="flex flex-col py-4">
      <span class="font-regular text-[18px]">Paso 6 de 6</span>
      <h1 class="font-bold text-[30px] pb-8">Desplegar sistema de IA</h1>

      <h2 class="font-bold text-[24px] pb-6">Datos económicos</h2>

      <h3 class="font-bold text-[18px] pb-6">Impacto económico</h3>

      <div class="grid grid-cols-2">
        <div class="flex flex-col">
          <desy-select
            formControlName="costBenefitAnalysis"
            classes="min-w-full">
            <desy-label>Análisis coste-beneficio*</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay un análisis coste-beneficio
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'costBenefitAnalysis', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
          <ng-container *ngIf="!costBenefitExtraFilled() && costBenefitRequired()">
            <desy-error-message class="block font-semibold">
              Rellena obligatoriamente uno de los dos campos siguientes:
            </desy-error-message>
          </ng-container>
        </div>
      </div>
      <ng-container *ngIf="costBenefitRequired()">
        <div class="grid grid-cols-2 mt-4">
          <div class="flex flex-col">
            <span class="text-[14px] text-neutral-dark">Con CSV (Código identificador del documento)</span>
            <desy-input
              id="costBenefitAnalysisCsv"
              [classes]="'w-full'"
              [placeholder]="'Validación 1, validación 2...'"
              formControlName="costBenefitAnalysisCsv"></desy-input>
          </div>
        </div>
        <div class="flex flex-col">
          <span class="text-[14px] text-neutral-dark block">Descripción</span>
          <desy-textarea
            id="costBenefitAnalysisDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la validación contra controles ISO 42001'"
            formControlName="costBenefitAnalysisDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
        </div>
      </ng-container>

      <h2 class="font-bold text-[24px] pb-6 pt-6">Impacto y evaluación</h2>

      <h3 class="font-bold text-[18px] pb-6">Valor público</h3>

      <div class="grid grid-cols-2">
        <div class="mr-6 flex flex-col">
          <desy-select
            formControlName="publicValue"
            classes="min-w-full">
            <desy-label>Medición de valor público</desy-label>
            <desy-option
              [disabled]="true"
              [selected]="true"
              [hidden]="true">
              Selecciona si hay medición
            </desy-option>
            <desy-option
              *ngFor="let item of binaryOptions"
              [id]="item.label"
              [value]="item.value">
              {{ item.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'publicValue', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>

      <ng-container *ngIf="publicValueRequired()">
        <div class="flex flex-col -mt-4 mb-4">
          <desy-label>Descripción*</desy-label>
          <desy-textarea
            id="publicValueDescription"
            [classes]="'w-full'"
            [placeholder]="'Describe aquí la medición del valor público del sistema de IA'"
            formControlName="publicValueDescription"
            [rows]="3"
            [maxlength]="500"></desy-textarea>
          <ng-container
            *ngIf="getError(form, 'publicValueDescription', formSubmitted()) as error; else publicValueDescriptionInfo">
            <desy-error-message>
              {{ error }}
            </desy-error-message>
          </ng-container>
          <ng-template #publicValueDescriptionInfo>
            <span class="text-[14px] text-neutral-dark info-message block">Puedes escribir hasta 500 caracteres</span>
          </ng-template>
        </div>
      </ng-container>
    </div>
  </div>
</form>
